export const POST_FEED_PREVIEW_BUTTON_LABEL = 'post-feed-preview.button-label';
